export const styles = (theme) => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: '999',
    padding: theme.spacing(1, 0),
    margin: theme.spacing(4, 0),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1, 0),
      margin: theme.spacing(2, 0),
    },
  },

  greyBackground: {
    backgroundColor: '#f2f2f2',
    transition: 'background-color .5s',
  },

  paper: {
    padding: theme.spacing(1, 2, 1, 4),
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
    borderRadius: 50,
  },

  greyLabel: {
    color: '#999999',
  },

  searchText: {
    fontWeight: 'bold',
    fontFamily: 'Poppins',
    marginBottom: theme.spacing(0.5),
  },

  searchTextSmall: {
    fontFamily: 'Poppins',
    marginBottom: theme.spacing(0.5),
    fontSize: 11,
  },

  searchButton: {
    backgroundColor: '#fff',
    color: theme.palette.primary.dark,
    '&:hover': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },

  searchParamsSection: {
    marginTop: theme.spacing(2),
  },
})
